export const NUMBER_REGEXP = /^[0-9\b.,]+$/;
export const SPORT_NAVBAR_INTERVAL_TIMING = 120000;
export const SPORT_CONFIG_INTERVAL_TIMING = 300000;
export const SPORT_SKIN_CONFIG_INTERVAL_TIMING = 120000;
export const SPORT_WIDGET_INTERVAL_TIMING = 120000;
export const WALLET_INTERVAL_TIMING = 30000;
export const COUPON_UPDATE_INTERVAL_TIMING = 7000;
